import type React from "react";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import {
    Chip,
    Container,
} from "app/pages/digital-suite/home-page/components/RecentsWidget/KeywordListLabel/styledComponents";

interface KeywordListLabelProps {
    name: string;
}

export const KeywordListLabel: React.FC<KeywordListLabelProps> = (props) => {
    return (
        <Container>
            <span>{props.name}</span>
            <Chip>
                <I18n>digitalmarketing.homepage.recents_widget.keyword_group.suffix</I18n>
            </Chip>
        </Container>
    );
};
